module.exports = __webpack_public_path__ + "img/youtube.b209fd9e.svg";